import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {SubSection} from '../../model/sub-section';
import {Group} from '../../model/group';
import {Field} from '../../model/field';
import {StepperBuilderService} from '../../../../avisDePub/creer/services/stepper.builder.service';
import {EformsSubjectService} from '../../services/eforms-subject.service';
import {Preference} from '../../../../avisDePub/preferences-avis-de-pub/model/preference';
import {EformConditionsService} from '../../services/eform-conditions.service';
import {EformDataService} from '../../services/eform-data.service';
import {EformElementsService} from '../../services/efom-elements.service';
import {EformDuplicableEntityService} from '../../services/eform-duplicable-entity.service';
import {ENoticeTypeXsd} from '../../../../../models/enums/enotice-type-xsd.enum';
import {EformsToolsService} from '../../services/e-forms-tools.service';
import {EFormsOrgService} from '../../services/e-forms-org.service';
import {DuplicableElementsInputIdEnum} from '../../enum/duplicable-elements-input-id.enum';
import {IndexTrackerService} from "../../services/index-tracker.service";
import {EformConditionsV2Service} from "../../services/eform-conditions-v2.service";
import {EformsFieldCounterService} from '../../services/eforms-field-counter.service';
import {EformDuplicableFieldsService} from '../../services/eform-duplicable-fields.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {filter, first, takeUntil} from 'rxjs/operators';
import {EformAccordionService} from '../../services/eform-accordion.service';

@Component({
  selector: 'app-sub-section',
  templateUrl: './sub-section.component.html',
  styleUrls: ['../e-forms-generator/e-forms-generator.component.css']
})
export class SubSectionComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() indexPage: any;
  @Input() subSection: SubSection = {} as SubSection;
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() noticeValue: any = {};
  @Output() newSubSection = new EventEmitter();
  @Output() deleteSubSection = new EventEmitter();
  @Input() repeatablePath: string;
  @Input() repeatablePathWithIndex: string;
  @Input() prefixId: string;
  @Input() indexGrp: string = '';
  @Input() parentsChild: any;
  @Input() linkForRouter: string;
  @Input() indexSection: string;
  @Input() getRepeatablePathWithIndexForSubSection: (SubSection) => string;
  @Input() getRepeatablePathForDuplicableElementFromParent: () => string;
  form: FormGroup;
  elementsDuplicableCount: number = 0; // ✅ Initialisé à 0, sera mis à jour par le subscribe
  displayedElementIndex: number = 0;
  groupDuplicable: any;
  isAfterDuplicableElementLoading: boolean = false;
  repeatablePathForElementDuplicable: string;
  private subSectionLoadingComplete: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private destroy$ = new Subject<void>();
  duplicableElements: any[] = [];
  // 🔧 FIX 2026-02-11: Protection contre les créations multiples d'éléments duplicables
  private isCreatingDuplicableElement: boolean = false;

  constructor(
    private stepperBuilderService: StepperBuilderService, private eformsSubjectService: EformsSubjectService,
    private eformConditionService: EformConditionsService, private eformDataService: EformDataService,
    private eformElementsService: EformElementsService, private eformDuplicableEntityService: EformDuplicableEntityService,
    private eformsToolsService: EformsToolsService, private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private indexTrackerService: IndexTrackerService, private eformConditionV2Service: EformConditionsV2Service,
    private eformsFieldCounterService: EformsFieldCounterService,
    private eFormsOrgService: EFormsOrgService,
    private eformAccordionService: EformAccordionService,
    private eformDuplicableFieldsService: EformDuplicableFieldsService
  ) {
  }

  // Propriété mémorisée pour éviter les recalculs en boucle dans le template
  // ✅ FIX 2026-01-13: Contient maintenant les éléments réels avec leurs IDs
  counterArray: any[] = [];

  /**
   * Met à jour le tableau de compteurs - contient maintenant les éléments réels
   * ✅ FIX 2026-01-13: Au lieu de [0,1,2], on a [{id: "CON-0001", index: 0}, {id: "CON-0002", index: 1}, ...]
   * Cela permet à Angular de correctement tracer les éléments lors des suppressions
   */
  private updateCounterArray(): void {
    const type = this.subSection?.groups?.[0]?._idScheme;
    if (!type || type === 'UNK') {
      this.counterArray = [];
      return;
    }

    // Récupérer les éléments réels depuis la liste
    const currentList = this.eformDuplicableEntityService.listDuplicableEntity.getValue();
    const currentElements = currentList.filter(elt => {
      if (!elt || !elt.id) return false;
      const elementType = elt.id.split('-')[0];
      return elementType === type;
    });

    // Créer un tableau d'objets avec l'ID et l'index
    // Cela permet au trackBy de retourner un ID unique stable
    this.counterArray = currentElements.map((element, index) => ({
      id: element.id,
      index: index
    }));
  }

  /**
   * TrackBy basé sur l'ID réel de l'élément pour forcer la destruction/recréation lors de suppressions
   * ✅ FIX 2026-01-13: Utiliser l'ID réel depuis l'objet dans counterArray
   * Cela force Angular à détruire les composants supprimés et à recréer les composants restants
   */
  trackByDuplicableId(index: number, item: any): string {
    // item est maintenant un objet {id: "CON-0001", index: 0}
    const trackId = item?.id || `fallback_${index}`;
    return trackId;
  }

  ngOnInit(): void {
    //Suppression temporaire du point de contact spécifique
    if (this.subSection?.groups) {
      this.subSection.groups = this.subSection.groups.filter(g => g.id != 'GR-Touch-Point');
    }

    //Quand on reçoit une nouvelle liste d'entités duplicable, on actualise le compteur d'organisations
    this.eformDuplicableEntityService.listDuplicableEntity.pipe(
      takeUntil(this.destroy$)
    ).subscribe(duplicableElementsList => {
      // ✅ Vérifier que type existe avant de continuer
      const type = this.subSection?.groups?.[0]?._idScheme;

      if (!type || type === 'UNK') {
        // Pas d'élément duplicable dans cette sous-section, ignorer
        return;
      }

      const oldCount = this.elementsDuplicableCount;

      // 🔥 CALCUL du nombre réel d'éléments de ce type dans la liste
      // Le type doit être extrait de l'ID (format: "ORG-0001" → type "ORG")
      const currentElements = duplicableElementsList.filter(elt => {
        if (!elt || !elt.id) return false;
        const elementType = elt.id.split('-')[0];
        return elementType === type;
      });
      const newCount = currentElements.length;

      // 🔥 Mise à jour du compteur AVANT de mettre à jour le tableau
      this.elementsDuplicableCount = newCount;

      // Mettre à jour le tableau mémorisé
      this.updateCounterArray();

      // ✅ FIX 2026-01-28: Forcer la détection de changement quand le compteur change
      // Utiliser setTimeout pour éviter les erreurs NG0100 (cycle de détection en cours)
      if (oldCount !== newCount) {
        setTimeout(() => {
          this.cd.detectChanges();
        }, 0);
      }
    });

    switch (this.subSection.groups[0]._idScheme) {
      case 'ORG':
        this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.organisationNotice));
        //Suppression temporaire du point de contact spécifique
        if(this.groupDuplicable?.subGroups){
          this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
        }
        break;
      case 'RES':
        // ✅ FIX 2026-03-18: Vérifier que resultNotice existe avant de l'utiliser
        // Sinon, utiliser le groupe de la sous-section comme fallback
        if (this.eformDuplicableEntityService.resultNotice) {
          this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.resultNotice));
        } else {
          console.warn('[⚠️ SUB-SECTION] resultNotice est null, utilisation du groupe de la sous-section comme fallback');
          this.groupDuplicable = this.subSection.groups[0] ? JSON.parse(JSON.stringify(this.subSection.groups[0])) : null;
        }
        //Suppression temporaire du point de contact spécifique
        if(this.groupDuplicable?.subGroups){
          this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
        }
        break;
      case 'TEN':
        this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.tenderNotice));
        //Suppression temporaire du point de contact spécifique
        if(this.groupDuplicable?.subGroups){
          this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
        }
        break;
      case 'CON':
        this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.settledContractNotice));
        //Suppression temporaire du point de contact spécifique
        if(this.groupDuplicable?.subGroups){
          this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
        }
        break;
      case 'TPA':
        this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.tenderingPartyNotice));
        break;

      default:
        break;
    }
    //On initalise les sous-sections qui ne le sont pas
    this.repeatablePathWithIndex = this.getRepeatablePathWithIndexForSubSection(this.subSection);
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();

    // Initialiser le tableau de compteurs
    this.updateCounterArray();
  }

  ngAfterViewInit() {
    //Dans le cas de l'edition, on cherche les elements répétable à initialiser
    let elementToCreate = this.eformConditionService.findElementsToCreate(this.subSection, this.repeatablePathWithIndex, this.noticeValue);
    if (elementToCreate?.length) {
      elementToCreate.forEach(e => {
        this.addSubSection();
      });
    }
  }

  isDuplicableElement() {
    return Object.values(DuplicableElementsInputIdEnum).includes(this.subSection.id) && !this.eformDuplicableEntityService.isCreationButBeforeFirstSave.getValue();
  }

  newField($event) {
    const field: Field = Object.assign({}, JSON.parse(JSON.stringify($event)));
    const ids = this.subSection.fields.map(gr => gr.id);
    let elementNumber = 1;
    while (ids.includes(field.id.split('_')[0] + '_' + elementNumber)) {
      elementNumber++;
    }
    field.id = field.id.split('_')[0] + '_' + elementNumber;
    const indexToSplice = this.subSection.fields.filter(el => el.id.startsWith($event.id)).length;
    this.subSection.fields.splice((this.subSection.fields as any).findIndex(el => el.id === $event.id) + indexToSplice, 0, field);


    this.repeatablePath = field.jsonPath + '_SEPSEP_' + (elementNumber);
  }

  deleteField($event: any) {
    this.subSection.fields = this.subSection.fields.filter(obj => obj !== $event);
  }

  isInteger(indexGrp) {
    return Number.isInteger(indexGrp);
  }

  getIncr(id) {
    return id.split('_').slice(-1) == undefined ? 0 : id.split('_').slice(-1);
  }

  loadDuplicableElement($event) {
    // Marquer le début du chargement
    this.subSectionLoadingComplete.next(false);
    const type = this.subSection.groups[0]._idScheme || 'UNK';

    //on ferme avant, tous les accordeons
    this.displayedElementIndex = -1;

    const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire].toLowerCase();


    // ✅ FIX 2026-01-09: Réinitialiser les IDs des éléments répétables pour ce type d'élément duplicable
    // Cela évite l'accumulation de doublons lors du rechargement d'un élément duplicable
    // La logique est GÉNÉRIQUE pour tous les types (ORG, RES, TEN, CON, TPA, LOT, PAR)
    // ⚠️ IMPORTANT: Le format doit correspondre à celui de getStableParentContext: "element_REAL_INDEX"
    // 🔧 FIX 2026-03-17: Utiliser actuaEntityIndex au lieu de _0 hardcodé.
    // Sans ça, le clear ne nettoie que le contexte _0 alors que getStableParentContext
    // stocke les IDs sous tenderingparty_1 (vrai index), causant la perte des tenderers
    // au rechargement du 2ème TPA (les IDs restent dans existingItemIds → pas de création).
    const realIndex = this.eformDuplicableEntityService.actuaEntityIndex ?? 0;
    const parentContextBaseMap: { [key: string]: string } = {
      'ORG': 'organization',
      'RES': 'lotresult',
      'TEN': 'lottender',
      'CON': 'settledcontract',
      'TPA': 'tenderingparty',
      'LOT': 'procurementprojectlot',
      'PAR': 'procurementprojectlot'
    };
    const parentContextBase = parentContextBaseMap[type];
    if (parentContextBase) {
      const parentContext = `${parentContextBase}_${realIndex}`;
      this.eformConditionService.clearExistingItemsForParentContext(parentContext);
    }

    // ✅ FIX 2026-01-09: SUPPRIMER les contrôles du FormGroup AVANT de charger les nouvelles données
    // Cela évite l'accumulation de doublons (receivedSubmissionsStatistics x3, etc.)
    // Le formulaire sera recréé automatiquement avec les bonnes données lors du rendu
    // ✅ FIX 2026-03-06: Passer le type de notice dynamiquement pour supporter tous les formulaires
    // (contractnotice pour F15-F24, contractawardnotice pour F25-F40, priorinformationnotice pour F1-F14)
    if (this.formGroup && type !== 'UNK') {
      this.eformDataService.clearDuplicableElementControls(this.formGroup, type, firstItemName);
    }

    // Créer l'ID unique pour cet élément (même logique que dans duplicable-element)
    const elementId = `${type}_${$event.index}`;


    switch (this.subSection.groups[0]._idScheme) {
      case 'ORG':
        this.loadOrganisation(firstItemName, $event);
        break;
      case 'RES':
        this.loadResult(firstItemName, $event);
        break;
      case 'TEN':
        this.loadTender(firstItemName, $event);
        break;
      case 'CON':
        this.loadSettledContract(firstItemName, $event);
        break;
      case 'TPA':
        this.loadTenderingParty(firstItemName, $event);
        break;

      default:
        break;
    }

    this.displayedElementIndex = $event.index;
    this.isAfterDuplicableElementLoading = true;


    // ✅ FIX 2026-01-20: Enregistrer l'index réel affiché pour ce type d'élément duplicable
    // Cela permet aux flatFields d'utiliser le bon index lors du scan du formulaire
    this.eformConditionV2Service.setDisplayedRealIndex(type, $event.index);

    // ✅ FIX 2025-12-23: Forcer le redessinage SYNCHRONE pour garantir que les contrôles
    // du formulaire sont créés IMMÉDIATEMENT. Cela corrige le problème où organization: []
    // est vide lors de la navigation 1→3→2 car les contrôles n'étaient pas créés avant la sauvegarde.
    try {
      this.cd.detectChanges();
    } catch (e) {
      // En cas d'erreur NG0100, utiliser markForCheck comme fallback
      console.warn('[⚠️ SUB-SECTION] detectChanges error, falling back to markForCheck:', e.message);
      this.cd.markForCheck();
    }

    // 🔧 FIX 2026-03-17: 2ème detectChanges pour rendre immédiatement les groupes répétables
    // (tenderers, etc.) créés par findElementsToCreate lors du ngAfterViewInit du 1er cycle.
    // Sans ce 2ème appel, les groupes ajoutés en extra (2ème/3ème tenderer) ne s'affichent
    // qu'au prochain cycle Angular (~16ms+), causant un flash visible.
    // Pas de risque de boucle infinie : les groupes manuels (_1, _2) ont le flag
    // isManuallyAddedGroup qui empêche findElementsToCreate de créer des doublons.
    try {
      this.cd.detectChanges();
    } catch (e) {
      // Ignoré silencieusement — le 1er cycle a déjà rendu l'essentiel
    }

    // ✅ FIX: Réinitialiser repeatablePathForElementDuplicable avec le bon index
    // Cela corrige le problème de persistance des champs (comme BT-507-Organization-Company)
    // lorsqu'on change d'organisation. Le chemin doit refléter l'index de l'élément duplicable affiché.
    this.repeatablePathForElementDuplicable = this.getRepeatablePathForDuplicableElementFromParent();

    // Surveiller la completion de la sous-section spécifique avec le nouveau système (sauf pour UNK)
    if (type !== 'UNK') {
      this.eformsFieldCounterService.getSubSectionCountsObservable().subscribe(counts => {
        const elementCount = counts.get(elementId);
        if (elementCount && elementCount.isComplete) {
          this.subSectionLoadingComplete.next(true);
        }
      });
    } else {
      // Pour les éléments UNK, marquer comme terminé immédiatement
      this.subSectionLoadingComplete.next(true);
    }
  }

  /**
   * Calcule le nombre de champs attendus pour un élément duplicable donné
   */
  private calculateExpectedFieldsForElement($event: any): number {
    // Cette méthode n'est plus utilisée avec le nouveau système
    return 0;
  }

  /**
   * Estime le nombre de champs basé sur la structure de la sous-section
   */
  private estimateFieldsFromSubSection(): number {
    // Cette méthode n'est plus utilisée avec le nouveau système
    return 0;
  }

  /**
   * Compte récursivement les champs dans un groupe
   */
  private countFieldsInGroup(group: any): number {
    // Cette méthode n'est plus utilisée avec le nouveau système
    return 0;
  }

  /**
   * Observable pour savoir quand le chargement de tous les champs de la sous-section est complet
   * @returns Observable<boolean> - true quand le chargement est terminé
   */
  public getSubSectionLoadingStatus() {
    return this.subSectionLoadingComplete.asObservable();
  }

  /**
   * Méthode pour vérifier l'état actuel du chargement
   * @returns boolean - true si le chargement est complet
   */
  public isSubSectionLoadingComplete(): boolean {
    return this.subSectionLoadingComplete.getValue();
  }

  displayGroup(index: number) {
    return !this.subSection.groups[0]?.hidden && index === this.displayedElementIndex && this.isAfterDuplicableElementLoading;
  }

  newGroup($event: any) {
    // ✅ FIX 2026-03-23: Distinguer l'initialisation (chargement données existantes)
    // de l'action utilisateur (clic sur "+").
    // Lors d'un clic "+", on déclenche une sauvegarde immédiate après que Angular
    // ait rendu les nouveaux contrôles, pour éviter de perdre les nouvelles nomenclatures.
    const isInitializing = $event?.isInitializing || false;
    const group: Group = Object.assign({}, JSON.parse(JSON.stringify($event?.data || $event)));


    const ids: any = this.subSection.groups.map(gr => gr.id);
    group.subGroups = this.eformElementsService.clearRepeatedGroups(group.subGroups);

    //Suppression temporaire du point de contact spécifique dans les subGroups
    if(group?.subGroups){
      group.subGroups = group.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }

    let elementNumber = 1;
    if (group.id.includes('_')) {
      group.repeatedId = group.id.split('_').slice(1).map(Number);
      group.id = group.id.split('_').slice(0, -1).join('_');
    } else {
      group.repeatedId = [0];
    }
    // On cherche le premier id disponible pour le nouveau groupe
    while (ids.includes(group.id + '_' + elementNumber)) {
      elementNumber++;
    }

    group.id = group.id.split('_')[0];
    group.repeatedId.splice(-1, 1, elementNumber);
    group.repeatedId.forEach(id => group.id += '_' + id);

    group.subGroups = this.eformElementsService.updateIdsRecursively(group.subGroups, [...group.repeatedId]);

    let seekingId = group.id.split('_')[0];
    const regex = new RegExp(`^${seekingId}`);
    this.subSection.groups.splice(ids.findLastIndex(value => regex.test(value)) + 1, 0, group);


    this.isDeletable(group.id);

    // ✅ FIX 2026-03-23: Déclencher une sauvegarde lors d'une action utilisateur (clic "+")
    // pour s'assurer que les nouveaux groupes répétables (ex: nomenclatures complémentaires)
    // sont bien persistés. Le debounce de 100ms laisse Angular le temps de créer les
    // FormControls avant que la sauvegarde ne soit effectuée.
    // NE PAS sauvegarder lors de l'initialisation (chargement des données existantes).
    if (!isInitializing) {
      this.eformDuplicableEntityService.needSaveAfterChangeAccordion.next(true);
    }

    // 🔧 FIX 2026-02-26: Notifier le service pour replier les autres accordéons du même type
    // et garder ouvert uniquement le nouveau créé
    const groupType = this.getGroupType(group.id);
    if (groupType) {
      // Petit délai pour permettre au DOM de se mettre à jour avec le nouveau groupe
      setTimeout(() => {
        this.eformAccordionService.collapseOthers(groupType, group.id);
      }, 100);
    }
  }

  /**
   * 🔧 FIX 2026-02-26: Extrait le type de groupe à partir d'un ID
   * Ex: "GR-Lot-AwardCriteria-Criterion_1" -> "GR-Lot-AwardCriteria-Criterion"
   */
  getGroupType(elementId: string): string {
    return this.eformAccordionService.extractGroupType(elementId);
  }

  deleteGroup($event: any) {
    let _group = $event.group ? $event.group : $event;

    // 🔧 FIX 2026-02-16: On récupère l'index AVANT de modifier la liste
    let indexToDelete = 0;
    if (_group.repeatedId) {
      indexToDelete = _group.repeatedId.slice(-1)[0];
    } else {
      indexToDelete = 0;
    }

    // 🔧 FIX 2026-02-16: Calculer le repeatablePathWithIndex avec l'index explicite
    const repeatablePathForDelete = this.getRepeatablePathWithIndexForSubGroupWithExplicitIndex(_group, indexToDelete);

    //On supprime le groupe du formulaire avec l'index explicite
    let pathElements: Array<string> = _group.jsonPath.split('.');
    pathElements.pop();
    this.formGroup = this.stepperBuilderService.removeLastControl(this.formGroup, pathElements, repeatablePathForDelete, indexToDelete);

    if (this.subSection.groups.length > 1) {
      this.subSection.groups = this.subSection.groups.filter(obj => obj !== _group);
    }


    this.subSection.groups.filter(group => group.id.includes(_group.id.split('_')[0])).forEach(group => {
      if (group.repeatedId && group.repeatedId.slice(-1)[0] > indexToDelete) {
        group.repeatedId.push(group.repeatedId.pop() - 1);
        group.id = group.id.split('_')[0];
        group.repeatedId.forEach(id => group.id += '_' + id);
        group.subGroups = this.eformElementsService.updateIdsRecursively(group.subGroups, [...group.repeatedId]);
      }
      if (!_group.id.includes('_') && group.repeatedId && group.repeatedId.slice(-1)[0] === 0) {
        group.id = group.id.slice(0, -2);
      }
    });
    this.isDeletable(_group.id);
  }

  /**
   * 🔧 FIX 2026-02-16: Nouvelle méthode pour calculer le repeatablePathWithIndex avec un index explicite
   */
  private getRepeatablePathWithIndexForSubGroupWithExplicitIndex = (group, explicitIndex: number): string => {
    if (group.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      return pathToReturn + group.jsonPath + '_INDEX_' + explicitIndex;
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  getRepeatablePathWithIndexForSubGroup = (group, isForDelete?): string => {
    if (group.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }

      let index = this.eformDataService.getArray(group, this.formGroup, this.repeatablePathWithIndex, undefined, undefined, undefined, undefined, undefined, isForDelete);

      this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, group.jsonPath, Number(index), undefined, isForDelete);
      return pathToReturn + group.jsonPath + '_INDEX_' + (index);
    } else {
      return this.repeatablePathWithIndex;
    }
  }

  newDuplicableElement(group: Group) {
    const type = group._idScheme;

    // 🔧 FIX 2026-02-11: Protection contre les créations multiples
    if (this.isCreatingDuplicableElement) {
      return;
    }
    this.isCreatingDuplicableElement = true;

    // 🔧 FIX 2026-02-17: Nettoyer les contrôles du formulaire AVANT la création
    // Cela évite que les données du TPA actuellement ouvert (tenderer, subcontractor)
    // soient envoyées au backend lors de la sauvegarde qui précède la création.
    // Sans ce nettoyage, les contrôles existants sont scannés et sauvegardés,
    // ce qui crée des données en double (tenderer: Array(2) au lieu de Array(1))
    // ✅ FIX 2026-03-06: Passer le type de notice dynamiquement
    const firstItemNameForCreate = ENoticeTypeXsd[this.stepperBuilderService.formulaire]?.toLowerCase();
    if (this.formGroup && type !== 'UNK') {
      this.eformDataService.clearDuplicableElementControls(this.formGroup, type, firstItemNameForCreate);
    }

    // 🔧 FIX 2026-02-17: Nettoyer également noticeValue pour ce type d'élément
    // pour éviter que les anciennes données ne soient sauvegardées
    this.clearNoticeValueForType(type);

    //On incrémente l'index
    this.indexTrackerService.addDuplicableElement(type);

    // ✅ FIX 2026-03-05: Activer la protection lors de l'ajout d'un nouvel élément
    // pour éviter que les champs conditionnels ne soient évalués avant le chargement
    this.eformDuplicableFieldsService.startLoadingDuplicableElement(type);

    //On ajoute le flatFields qui va recupérer les informations
    this.eformConditionV2Service.addDuplicableFieldsByType(type);
    this.eformDuplicableEntityService.addNewDuplicableEntity(this.eformDuplicableEntityService.currentAvisId.getValue(), type).subscribe(() => {

      // 🔄 Recharger la liste depuis le backend pour mettre à jour listDuplicableEntity
      // Le subscribe détectera l'ajout et mettre à jour automatiquement elementsDuplicableCount
      this.eformDuplicableEntityService.getIdsAndNamesByAvisId(this.eformDuplicableEntityService.currentAvisId.getValue()).subscribe(listIdsAndNames => {

        // Définir l'index du nouvel élément AVANT de mettre à jour la liste
        const newElementsCount = listIdsAndNames.filter(e => e && e.id && e.id.split('-')[0] === type).length;
        const newIndex = newElementsCount - 1;

        // Définir displayedRealIndex AVANT de mettre à jour la liste
        this.eformConditionV2Service.setDisplayedRealIndex(type, newIndex);

        // ✅ FIX 2026-03-05: S'abonner à componentReady$ AVANT de créer le composant
        // pour éviter de rater l'événement (race condition).
        // L'événement sera émis dans ngOnInit() du nouveau composant.
        this.eformDuplicableEntityService.componentReady$.pipe(
          filter(ready => ready.type === type && ready.index === newIndex),
          first()
        ).subscribe(() => {
          // ✅ FIX 2026-03-05: Attendre 500ms pour laisser le temps au composant de charger ses données
          // avant de désactiver la protection et de réévaluer les champs conditionnels
          setTimeout(() => {
            this.eformDuplicableFieldsService.stopLoadingDuplicableElement(type);

            // ✅ FIX 2026-03-06: Forcer un rescan des champs conditionnels après désactivation de la protection
            // pour que les champs comme BT-3202-Contract s'affichent correctement dans le nouveau marché
            this.eformConditionV2Service.rescanFlatFieldsFromForm(this.formGroup);

            // On peut ouvrir l'accordéon
            this.eformDuplicableEntityService.setDisplayedElementIndex(type, newIndex);
          }, 500);
        });

        // Maintenant mettre à jour la liste (ce qui va créer le nouveau composant via *ngFor)
        // Le composant appellera ngOnInit() → notifyComponentReady() → componentReady$.next()
        this.eformDuplicableEntityService.listDuplicableEntity.next(listIdsAndNames);


        // 🔧 FIX 2026-05-21: Réinitialiser groupDuplicable depuis le template propre AVANT d'afficher
        // le nouvel élément, pour éviter qu'il hérite des sous-groupes ajoutés par l'élément précédent
        // (ex: GR-Tenderer_1 ajouté à TPA_0 qui apparaissait dans TPA_1 à sa création)
        this.resetGroupDuplicableForType(type);

        // Définir l'index du dernier élément ajouté pour l'afficher
        this.displayedElementIndex = newIndex;


        // Réinitialiser repeatablePathForElementDuplicable pour le nouvel index
        this.repeatablePathForElementDuplicable = undefined;

        // ✅ FIX NG0100: Utiliser markForCheck au lieu de detectChanges
        this.cd.markForCheck();

        // 🔧 FIX 2026-02-11: Réinitialiser le flag après la création
        this.isCreatingDuplicableElement = false;
      });
    }, (error) => {
      // Réinitialiser le flag en cas d'erreur
      this.isCreatingDuplicableElement = false;
    });
  }

  /**
   * 🔧 FIX 2026-05-21: Réinitialise groupDuplicable depuis le template propre du service
   * pour le type d'élément duplicable donné. Appelé avant d'afficher un nouvel élément
   * pour éviter qu'il hérite des sous-groupes mutés par l'élément précédent.
   */
  private resetGroupDuplicableForType(type: string): void {
    let template: any = null;
    switch (type) {
      case 'TPA':
        template = this.eformDuplicableEntityService.tenderingPartyNotice;
        break;
      case 'RES':
        template = this.eformDuplicableEntityService.resultNotice;
        break;
      case 'TEN':
        template = this.eformDuplicableEntityService.tenderNotice;
        break;
      case 'CON':
        template = this.eformDuplicableEntityService.settledContractNotice;
        break;
      default:
        break;
    }
    if (template) {
      this.groupDuplicable = JSON.parse(JSON.stringify(template));
      this.cleanDuplicatedSubGroups(this.groupDuplicable);
    }
  }

  /**
   * 🔧 FIX 2026-02-17: Nettoie les sous-groupes numérotés d'un groupe duplicable
   * Quand on copie le template (tenderingPartyNotice, etc.), il peut contenir des sous-groupes
   * avec des suffixes numériques (GR-Tenderer_1, GR-Subcontractor_1) qui ont été ajoutés
   * lors d'une session précédente. On ne garde que les éléments de base (sans suffixe ou avec _0).
   * Cette méthode nettoie récursivement tous les niveaux de sous-groupes.
   */
  private cleanDuplicatedSubGroups(group: any): void {
    if (!group) return;

    // Nettoyer subGroups
    if (Array.isArray(group.subGroups)) {
      group.subGroups = group.subGroups.filter(sg => {
        const id = sg?.id || '';
        // Garder les éléments sans suffixe numérique ou avec _0
        const hasNumericSuffix = /_\d+$/.test(id);
        const endsWithZero = id.endsWith('_0');
        return !hasNumericSuffix || endsWithZero;
      });

      // Nettoyer récursivement
      group.subGroups.forEach(sg => this.cleanDuplicatedSubGroups(sg));
    }

    // Nettoyer subSubGroups si présents
    if (Array.isArray(group.subSubGroups)) {
      group.subSubGroups = group.subSubGroups.filter(ssg => {
        const id = ssg?.id || '';
        const hasNumericSuffix = /_\d+$/.test(id);
        const endsWithZero = id.endsWith('_0');
        return !hasNumericSuffix || endsWithZero;
      });

      group.subSubGroups.forEach(ssg => this.cleanDuplicatedSubGroups(ssg));
    }
  }

  deleteDuplicableElement(group: Group, index) {
    const type = group._idScheme;

    // 🔧 FIX 2026-02-19: Mémoriser l'index affiché AVANT la suppression
    // pour pouvoir rouvrir l'accordéon correspondant après
    const previousDisplayedIndex = this.eformDuplicableEntityService.getDisplayedElementIndex(type);


    // 🔧 FIX 2026-02-17: Nettoyer les contrôles du formulaire AVANT la suppression
    // Cela évite que les données de l'élément actuellement ouvert soient envoyées
    // au backend lors de la sauvegarde qui précède la suppression.
    // Sans ce nettoyage, les contrôles existants sont scannés et sauvegardés,
    // ce qui crée des données en double lors du rechargement.
    // ✅ FIX 2026-03-06: Passer le type de notice dynamiquement
    const firstItemNameForDelete = ENoticeTypeXsd[this.stepperBuilderService.formulaire]?.toLowerCase();
    if (this.formGroup && type !== 'UNK') {
      this.eformDataService.clearDuplicableElementControls(this.formGroup, type, firstItemNameForDelete);
    }

    // 🔧 FIX 2026-02-17: Nettoyer également noticeValue pour ce type d'élément
    // pour éviter que les anciennes données ne soient sauvegardées
    this.clearNoticeValueForType(type);

    // 🔍 RÉCUPÉRATION DE L'ID RÉELLE depuis la liste backend
    const currentList = this.eformDuplicableEntityService.listDuplicableEntity.getValue();

    const currentElements = currentList.filter(elt => {
      if (!elt || !elt.id) return false;
      const elementType = elt.id.split('-')[0];
      return elementType === type;
    });

    if (!currentElements[index]) {
      // ✅ FIX 2026-01-28: Forcer la mise à jour de counterArray même si l'élément n'est pas trouvé
      // Cela peut arriver si la liste a déjà été mise à jour mais pas le counterArray
      this.updateCounterArray();
      this.cd.detectChanges();
      return;
    }

    const element = currentElements[index];
    const elementId = element.id; // Ex: "CON-0005" ou "CON-NOID0001"

    // Vérifier si c'est un élément avec un ID temporaire (sans ID technique du backend)
    const isNoTechnicalIdElement = element._hasEmptyTechnicalId || element._hasNoTechnicalId ||
      elementId.includes('EMPTY') || elementId.includes('NOID');

    // ✅ FIX 2026-01-28: Si on supprime une organisation, désactiver needSecondOrganization
    // pour éviter qu'elle soit recréée automatiquement quand on change de section
    if (type === 'ORG') {
      this.eFormsOrgService.setNeedSecondOrganization(false);
    }


    // 🔧 FIX 2026-02-16: Nettoyer existingItemIds pour ce type d'élément
    // Cela évite que findElementsToCreate ne soit trompé par les anciens IDs
    const typeToContext: { [key: string]: string } = {
      'TPA': 'tenderingparty_0',
      'CON': 'settledcontract_0',
      'TEN': 'lottender_0',
      'RES': 'lotresult_0',
      'ORG': 'organization_0'
    };
    const contextToClean = typeToContext[type];
    if (contextToClean) {
      this.eformConditionService.clearExistingItemsForParentContext(contextToClean);
    }

    //On diminue le compteur de 1 et remet le lastIndexes sur le premier
    this.indexTrackerService.removeDuplicableElement(type);
    //Suppression dans flatFields
    this.eformConditionV2Service.removeDuplicableFieldByTypeAndIndex(type, index);

    if (isNoTechnicalIdElement) {
      // Pour les éléments sans ID technique, supprimer localement sans appeler le backend

      // ✅ FIX 2026-01-13: Fermer TOUS les accordéons et réinitialiser l'état AVANT de mettre à jour la liste
      this.displayedElementIndex = -1;
      this.isAfterDuplicableElementLoading = false;
      this.eformDuplicableEntityService.closeAllAccordions(type);

      // ✅ FIX 2026-01-13 CRITIQUE: Supprimer l'élément du cache local pour éviter les NOID fantômes
      this.removeElementFromAvisCache(type, index);

      // Retirer l'élément de la liste locale
      const updatedList = currentList.filter(e => e !== element);

      // Réinitialiser les états "loaded" pour tous les éléments restants de ce type
      const remainingElements = updatedList.filter(e => e && e.id && e.id.split('-')[0] === type);

      for (let i = 0; i < remainingElements.length; i++) {
        this.eformDuplicableEntityService.unmarkDuplicableElementAsLoaded(type, i);
      }

      // ✅ FIX CRITIQUE 2026-01-13: Mettre à jour la liste - cela déclenche le subscribe qui met à jour counterArray
      this.eformDuplicableEntityService.listDuplicableEntity.next(updatedList);

      // FORCE RESCAN : Synchroniser flatFields après la mise à jour de la liste
      this.eformConditionV2Service.forceRescanAfterDeletion(this.formGroup, type, index);

      // Fermer tous les accordéons
      this.displayedElementIndex = -1;
      // ✅ FIX 2025-12-18: Notifier le service pour fermer tous les accordéons
      this.eformDuplicableEntityService.closeAllAccordions(type);

      // ✅ FIX 2026-01-28: Utiliser detectChanges pour une mise à jour synchrone de la vue
      this.cd.detectChanges();

      // 🔧 FIX 2026-02-20: Rouvrir automatiquement un accordéon après suppression
      // Utiliser setTimeout pour s'assurer que detectChanges a terminé et que les composants sont prêts
      if (previousDisplayedIndex !== -1 && remainingElements.length > 0) {
        let newIndexToOpen: number = -1;
        if (previousDisplayedIndex === index) {
          newIndexToOpen = 0;
        } else if (previousDisplayedIndex > index) {
          newIndexToOpen = previousDisplayedIndex - 1;
        } else {
          newIndexToOpen = previousDisplayedIndex;
        }
        if (newIndexToOpen >= 0 && newIndexToOpen < remainingElements.length) {
          // Utiliser setTimeout(0) pour exécuter après le cycle de détection Angular
          setTimeout(() => {
            this.eformDuplicableEntityService.requestOpenAccordion(type, newIndexToOpen);
          }, 0);
        }
      }

      return;
    }

    const elementNumericId = parseInt(elementId.split('-')[1], 10); // Ex: 5

    // ✅ FIX 2026-01-13: Fermer TOUS les accordéons et réinitialiser l'état AVANT de supprimer
    this.displayedElementIndex = -1;
    this.isAfterDuplicableElementLoading = false;
    this.eformDuplicableEntityService.closeAllAccordions(type);

    // ✅ FIX 2026-01-13 CRITIQUE: Supprimer l'élément du cache local AVANT l'appel backend
    // pour éviter que enrichListWithElementsFromAvis ne rajoute des NOID fantômes
    this.removeElementFromAvisCache(type, index);

    // ✅ ENVOI DU NUMÉRO RÉEL AU BACKEND (pas index + 1)
    this.eformDuplicableEntityService.deleteDuplicableEntity(this.eformDuplicableEntityService.currentAvisId.getValue(), elementNumericId, type).subscribe(() => {

      // 🔄 RECHARGER la liste depuis le backend pour obtenir les vrais IDs après suppression
      this.eformDuplicableEntityService.getIdsAndNamesByAvisId(this.eformDuplicableEntityService.currentAvisId.getValue()).subscribe(listIdsAndNames => {

        // ✅ CRITIQUE : Réinitialiser les états "loaded" pour tous les éléments restants de ce type
        const updatedList = listIdsAndNames;
        const remainingElements = updatedList.filter(e => e && e.id && e.id.split('-')[0] === type);

        for (let i = 0; i < remainingElements.length; i++) {
          this.eformDuplicableEntityService.unmarkDuplicableElementAsLoaded(type, i);
        }

        // ✅ FIX CRITIQUE 2026-01-13: Mettre à jour la liste - cela déclenche le subscribe qui met à jour counterArray
        this.eformDuplicableEntityService.listDuplicableEntity.next(listIdsAndNames);

        // 🔄 FORCE RESCAN : Synchroniser flatFields après la mise à jour de la liste
        this.eformConditionV2Service.forceRescanAfterDeletion(this.formGroup, type, index);

        // ✅ FIX 2026-01-28: Fermer les accordéons APRÈS la mise à jour de la liste
        // pour éviter que l'utilisateur ne voie l'élément fermé mais toujours présent
        this.displayedElementIndex = -1;
        this.eformDuplicableEntityService.closeAllAccordions(type);

        // 🔄 FORCER la détection de changement pour redessiner immédiatement la vue
        this.cd.detectChanges();

        // 🔧 FIX 2026-02-20: Rouvrir automatiquement un accordéon après suppression
        // Utiliser setTimeout pour s'assurer que detectChanges a terminé
        if (previousDisplayedIndex !== -1 && remainingElements.length > 0) {
          let newIndexToOpen: number = -1;
          if (previousDisplayedIndex === index) {
            newIndexToOpen = 0;
          } else if (previousDisplayedIndex > index) {
            newIndexToOpen = previousDisplayedIndex - 1;
          } else {
            newIndexToOpen = previousDisplayedIndex;
          }
          if (newIndexToOpen >= 0 && newIndexToOpen < remainingElements.length) {
            setTimeout(() => {
              this.eformDuplicableEntityService.requestOpenAccordion(type, newIndexToOpen);
            }, 0);
          }
        }
      });
    });
  }

  removeSubSection() {
    this.deleteSubSection.emit(this.subSection);
  }

  addSubSection() {
    this.newSubSection.emit(this.subSection);
  }

  getRepeatablePathWithIndexForInput = (field): string => {
    if (field.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      if (this.isDuplicableElement()) {
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, field.jsonPath, this.displayedElementIndex);
      } else {
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, field.jsonPath, Number((this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0')));
      }
      return pathToReturn + this.isRepeatableField(field) + field.jsonPath + '_INDEX_' + (this.getIndex(field.id).bool ? this.getIndex(field.id).value : '0');
    } else {
      return this.repeatablePathWithIndex;
    }
  };

  getRepeatablePathForDuplicableElement = (): string => {
    return this.repeatablePathForElementDuplicable;
  };

  getRepeatablePathWithIndexForGroup = (group): string => {
    if (group.jsonPath) {
      let pathToReturn = '';
      if (this.repeatablePathWithIndex && !this.repeatablePathWithIndex.includes('undefined')) {
        pathToReturn += this.repeatablePathWithIndex + '_SEPSEP_';
      }
      if (this.isDuplicableElement()) {
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable?.replace(/(\[\]\d+)(?!.*\[\]\d+)/, '[]'), group.jsonPath, this.displayedElementIndex);
        //Dans le cas d'un élément duplicable, on charge un seul élément à la fois pour des raisons de perf donc
        //On se base sur l'index 0.
        return pathToReturn + group.jsonPath + '_INDEX_0';
      } else {
        const arrayIndex = this.eformDataService.getArray(group, this.formGroup, this.repeatablePathWithIndex);
        this.repeatablePathForElementDuplicable = this.eformDuplicableEntityService.constructPathWithIndexForDuplicableElement(this.repeatablePathForElementDuplicable, group.jsonPath, arrayIndex);
        return pathToReturn + group.jsonPath + '_INDEX_' + arrayIndex;
      }
    } else if (this.repeatablePathWithIndex) {
      this.repeatablePathForElementDuplicable = ''
      return this.repeatablePathWithIndex;
    } else if (group.fields?.length > 0) {
      let tempRepeatablePathWithIndex = group.fields[0].jsonPath.slice(0, group.fields[0].jsonPath.indexOf('[]'));
      return tempRepeatablePathWithIndex + '_INDEX_' + (this.eformDataService.getArray(group, this.formGroup, this.repeatablePathWithIndex, tempRepeatablePathWithIndex));
    } else {
      this.repeatablePathForElementDuplicable = ''
      return '';
    }
  };

  isRepeatableField(field) {
    if (field._repeatable) {
      let tempJsonPath = field.jsonPath.slice(0, field.jsonPath.lastIndexOf('[]') + 2);
      let index = this.eformDataService.getArray(field, this.formGroup, this.repeatablePathWithIndex, tempJsonPath);

      // ✅ FIX: Pour les tableaux imbriqués dans organization (partylegalentity, ultimatebeneficialowner, partyname),
      // quand on est dans un élément duplicable (organization), l'index doit être 0 car chaque organisation
      // a ses propres tableaux imbriqués. getArray retourne le nombre total de contrôles créés,
      // pas l'index dans l'organisation courante.
      if (this.isDuplicableElement()) {
        const lowerPath = tempJsonPath.toLowerCase();
        const nestedArraysInOrg = ['partylegalentity[]', 'ultimatebeneficialowner[]', 'partyname[]'];
        const isNestedInOrg = lowerPath.includes('organization[]') &&
                              nestedArraysInOrg.some(arr => lowerPath.endsWith(arr));
        if (isNestedInOrg) {
          index = 0;
        }
      }

      return tempJsonPath + '_INDEX_' + index + '_SEPSEP_';
    } else {
      return '';
    }
  }

  indexSubSection() {
    return this.indexSection + '.' + Number(this.indexGrp + 1);
  }

  getIndex(id: string) {
    let element = id.split('_');
    return {value: id.split('_')[element.length - 1], bool: element.length > 1};
  }

  chargeDonneePreference(preference: Preference) {
    // ✅ FIX 2025-12-18: Désactiver les conditions pendant le chargement des préférences
    // pour permettre le remplissage des champs conditionnels (ex: BT-507-Organization-Company)
    this.eformConditionV2Service.setLoadingPreference(true);

    let pathElements = this.subSection.jsonPath.split('.');
    pathElements.pop();
    const form = this.eformsSubjectService.getField(pathElements, this.formGroup, this.repeatablePathWithIndex);
    for (let index = 0; index < preference?.content?.values.length; index++) {
      const element = preference?.content?.values[index];
      if (element.value !== null) {
        this.setPreference(form, element);
      }
    }

    // ✅ FIX 2025-12-18: Réactiver les conditions après le chargement avec un délai
    // pour laisser le temps aux valeurs de se propager dans le formulaire
    setTimeout(() => {
      this.eformConditionV2Service.setLoadingPreference(false);
    }, 100);
  }

  setPreference(form, element) {
    let current = form;
    const arrays = element.code.split('_');
    for (let j = 0; j < arrays.length; j++) {
      if (j === arrays.length - 1) {
        current = current?.controls[arrays[j]]?.controls['val']?.setValue(element.value);
      } else {
        if (arrays[j].includes('[]')) {
          current = current?.controls[arrays[j].replace('[]', '')]?.controls[0];
        } else {
          current = current?.controls[arrays[j]];
        }
      }
    }
  }

  parcoursUtilisateur(subSection) {
    return subSection.parcoursUtilisateur?.messageInfo;
  }

  isDuplicableElementDeletable(): boolean {
    return this.elementsDuplicableCount > 1;
  }

  /**
   * ✅ FIX 2026-01-13: Supprime un élément du cache local avisWithElementsDuplicable
   * pour éviter que enrichListWithElementsFromAvis ne rajoute des éléments NOID fantômes
   * après une suppression backend.
   */
  private removeElementFromAvisCache(type: string, index: number): void {
    const avisData = this.eformDuplicableEntityService.avisWithElementsDuplicable.getValue();
    if (!avisData?.jsonsaisieformulaire?.ann) return;

    const ann = avisData.jsonsaisieformulaire.ann;

    // Trouver le formulaire
    const formKey = Object.keys(ann).find(key =>
      key.includes('notice') && typeof ann[key] === 'object' && ann[key] !== null
    );
    if (!formKey) return;

    // Mapping des types vers les chemins dans l'avis
    const typeToArrayName: { [key: string]: string } = {
      'CON': 'settledcontract',
      'TEN': 'lottender',
      'RES': 'lotresult',
      'TPA': 'tenderingparty'
    };

    const arrayName = typeToArrayName[type];
    if (!arrayName) return;

    // Naviguer jusqu'à noticeresult
    const noticeResult = ann[formKey]?.ublextensions?.ublextension?.[0]?.extensioncontent?.eformsextension?.noticeresult;
    if (!noticeResult || !Array.isArray(noticeResult[arrayName])) return;

    // Supprimer l'élément à l'index donné
    noticeResult[arrayName].splice(index, 1);

    // Mettre à jour le BehaviorSubject avec le nouvel objet
    this.eformDuplicableEntityService.avisWithElementsDuplicable.next(avisData);
  }

  /**
   * 🔧 FIX 2026-02-16: Nettoie noticeValue pour un type d'élément duplicable donné
   * Cela évite que les anciennes données ne causent la création de sous-éléments fantômes
   */
  private clearNoticeValueForType(type: string): void {
    const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire]?.toLowerCase();
    if (!firstItemName || !this.noticeValue) return;

    // Mapping des types vers les chemins dans noticeValue
    const typeToPath: { [key: string]: { parentPath: string[], arrayName: string } } = {
      'TPA': {
        parentPath: ['ublextensions', 'ublextension', '0', 'extensioncontent', 'eformsextension', 'noticeresult'],
        arrayName: 'tenderingparty'
      },
      'CON': {
        parentPath: ['ublextensions', 'ublextension', '0', 'extensioncontent', 'eformsextension', 'noticeresult'],
        arrayName: 'settledcontract'
      },
      'TEN': {
        parentPath: ['ublextensions', 'ublextension', '0', 'extensioncontent', 'eformsextension', 'noticeresult'],
        arrayName: 'lottender'
      },
      'RES': {
        parentPath: ['ublextensions', 'ublextension', '0', 'extensioncontent', 'eformsextension', 'noticeresult'],
        arrayName: 'lotresult'
      },
      'ORG': {
        parentPath: ['ublextensions', 'ublextension', '0', 'extensioncontent', 'eformsextension', 'organizations'],
        arrayName: 'organization'
      }
    };

    const config = typeToPath[type];
    if (!config) return;

    // Naviguer jusqu'au parent
    let current = this.noticeValue[firstItemName];
    for (const key of config.parentPath) {
      if (!current) return;
      current = current[key];
    }

    // Vider le tableau si il existe
    if (current && Array.isArray(current[config.arrayName])) {
      current[config.arrayName] = [];
    }
  }

  private isDeletable(elementId) {
    let baseId = elementId;
    if (elementId.includes('_')) {
      baseId = elementId.split('_')[0];
    }
    let filteredElements = this.subSection.groups.filter(el => el.id === baseId || el.id.includes(baseId + '_'));
    //Si on en a plus d'un le bouton supprimer doit etre dispo sur toutes
    if (filteredElements.length > 1) {
      filteredElements.forEach(s => s.deletable = true);
    } else {
      //Sinon aucun bouton supprimer
      filteredElements.forEach(s => s.deletable = false);
    }
  }

  private loadOrganisation(firstItemName, $event) {

    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'organizations'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    target.organization = [this.eformsToolsService.propertyNamesToLowercase($event)];

    // Créer une copie propre de groupDuplicable
    this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.organisationNotice));
  }

  private loadResult(firstItemName, $event) {
    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'noticeresult'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    target.lotresult = [this.eformsToolsService.propertyNamesToLowercase($event)];

    // ✅ FIX 2026-03-18: Vérifier que resultNotice existe avant de l'utiliser
    if (this.eformDuplicableEntityService.resultNotice) {
      this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.resultNotice));
    } else {
      console.warn('[⚠️ SUB-SECTION loadResult] resultNotice est null, utilisation du groupe de la sous-section');
      this.groupDuplicable = this.subSection.groups[0] ? JSON.parse(JSON.stringify(this.subSection.groups[0])) : null;
    }
    //Suppression temporaire du point de contact spécifique
    if(this.groupDuplicable?.subGroups){
      this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }
  }

  private loadTender(firstItemName, $event) {

    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'noticeresult'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    target.lottender = [this.eformsToolsService.propertyNamesToLowercase($event)];
    this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.tenderNotice));
    //Suppression temporaire du point de contact spécifique
    if(this.groupDuplicable?.subGroups){
      this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }
  }

  private loadSettledContract(firstItemName, $event) {

    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'noticeresult'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    target.settledcontract = [this.eformsToolsService.propertyNamesToLowercase($event)];
    this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.settledContractNotice));
    //Suppression temporaire du point de contact spécifique
    if(this.groupDuplicable?.subGroups){
      this.groupDuplicable.subGroups = this.groupDuplicable.subGroups.filter(g=>g.id !='GR-Touch-Point');
    }
    // 🔧 FIX 2026-02-17: Nettoyer les sous-groupes numérotés du template
    this.cleanDuplicatedSubGroups(this.groupDuplicable);
  }

  private loadTenderingParty(firstItemName, $event) {
    const path = [
      'noticeValue',
      firstItemName,
      'ublextensions',
      'ublextension',
      '0',
      'extensioncontent',
      'eformsextension',
      'noticeresult'
    ];
    // Assurez-vous que toutes les propriétés existent, si elle n'existe pas on les initialise
    const target = this.eformDataService.ensurePropertyPath(this, path);

    // Assignez la valeur
    const tenderingPartyData = this.eformsToolsService.propertyNamesToLowercase($event);

    target.tenderingparty = [tenderingPartyData];

    this.groupDuplicable = JSON.parse(JSON.stringify(this.eformDuplicableEntityService.tenderingPartyNotice));

    // 🔧 FIX 2026-02-17: Nettoyer les sous-groupes numérotés du template
    this.cleanDuplicatedSubGroups(this.groupDuplicable);
  }

  hideAccordion(id) {
    return id.includes("GR-Procedure-LocalLegalBasisNoID") || id.includes("GR-Procedure-CrossBorderLaw");
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}


